import axiosInstance from "../Interceptor"

export const getActiveVouchersListApi = (payload) => {
 
	return axiosInstance
	.get(`inventory/api/v1/vouchers/?is_active=${payload}`)
		.then((res) => {
			
			return res
		})
		.catch((err) => {
		
			return err
		})
}